import React from "react";
import Article from "../../components/Article";
import FilterMarketplacesProvider from "../../components/FilterMarketplacesProvider";
import Header from "../../components/Header";
import { HeaderButtonList } from "../../components/Header/HeaderButtonList";
import HideFakeOrdersProvider from "../../components/HideFakeOrdersProvider";
import ButtonSwitchHideFakeOrders from "../../components/HideFakeOrdersProvider/ButtonSwitchHideFakeOrders";
import DashboardArticle from "./DashboardArticle";
import MarketplaceFilterPanel from "./MarketplaceFilterPanel";
import { PageDashboardFC } from "./types";

const PageDashboard: PageDashboardFC = () => {
  return (
    <HideFakeOrdersProvider>
      <FilterMarketplacesProvider>
        <Header
          title={"Статистика"}
          buttons={
            <>
              <HeaderButtonList>
                <ButtonSwitchHideFakeOrders />
              </HeaderButtonList>
            </>
          }
        />
        <Article>
          <MarketplaceFilterPanel />
          <DashboardArticle />
        </Article>
      </FilterMarketplacesProvider>
    </HideFakeOrdersProvider>
  );
};

export default PageDashboard;
